var map = {
	"./pr-1.png": "8e5a",
	"./pr-2.png": "e5bb",
	"./pr-3.png": "cd67",
	"./pr-4.png": "9030",
	"./pr-5.png": "042d",
	"./pr-6.png": "4b69"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c7cd";